import React from 'react';
import { Box } from '@mui/material';
import { BrandLogo } from '@coverright/shared/brand';

// CoverRight logo, preceded by the brand's logo when the visitor came through a branded entry point
export default function useLogo() {
  return (
    <BrandLogo
      coverRightLogo={
        <Box
          component="img"
          src="/assets/img/Logo.svg"
          alt="CoverRight"
          sx={{ height: 24, objectFit: 'contain', flexShrink: 0 }}
        />
      }
    />
  );
}
